const initialState = {
  id: undefined,
  name: '',
  amount: '',
  payer: undefined,
  payment_source: undefined,
  starts_at: undefined,
  interval_count: '',
  interval: undefined,
  end_type: undefined,
  ends_at: undefined,
  occurrences: undefined,
  errors: [],
  ui: {
    show: false,
    submitting: false,
  }
}

export default function recurringCharges(state = initialState, action){
  switch (action.type) {
    case "UPDATE_NEW_RECURRING_CHARGE_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "UPDATE_NEW_RECURRING_CHARGE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "BEGIN_SUBMIT_NEW_RECURRING_CHARGE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true,
        }
      };
    case "SUCCESS_SUBMIT_NEW_RECURRING_CHARGE":
      return {
        ...initialState,
      };
    case "FAILED_NEW_RECURRING_CHARGE":
      return {
        ...state,
        errors: action.payload.errors
      };
    case "RESET_NEW_RECURRING_CHARGE_FORM":
      return initialState;
    default:
      return state;
  }
}